<docs>
## TkSkuPopup Docs

* product 和 product-id 同时存在时
  * product 作为初始化显示，再根据 product-id 异步更新数据
  * 建议分开单独使用
* 等商品加上可购数量在加入超出购买数提示
* 把各大部分切分到不同组件，方便组合定制
</docs>

<template>
  <div class="tk-sku_popup" data-com="TkSkuPopup">
    <YuPopup :value="onPop" @input="fnPopChange">
      <div class="tk-sku_popup-box" v-if="onPop">
        <div class="tk-sku_popup-info">
          <div class="tk-sku_popup-img_box">
            <img class="tk-sku_popup-img" :src="oPro.feature_image | imgURL('172x172')" :alt="oPro.name" />
          </div>
          <div class="tk-sku_popup-pro">
            <div class="tk-sku_popup-name">{{ oPro.name }}</div>
            <template>
              <div class="tk-sku_popup-prices">
                <YuCurrency class="tk-sku_popup-price" :val="amountAfter" />
              </div>
            </template>
            <!-- <template v-if="oSku.id">
              <div class="tk-sku_popup-prices">
                <YuCurrency class="tk-sku_popup-price" :val="oSku.price" />
                <YuCurrency v-if="oSku.compare_price" class="tk-sku_popup-price_src" :val="oSku.compare_price" />
              </div>
            </template> -->
            <div class="tk-sku_popup-count"><!-- <span v-if="type === 'cart'" class="tk-sku_popup-count_stock">库存 {{ nNowStock }} 件</span> --><span>已售 {{ nNowSale }} 件</span></div>
          </div>
          <YuButton class="tk-sku_popup-close" type="text" @click="fnClose">
            <!-- <YuIcon class="tk-sku_popup-close_icon" name="close" slot="icon" /> -->
            <img class="tk-sku_popup-close_icon" src="./close.svg">
          </YuButton>
        </div>
        <div v-if="(oPro.options || []).length" class="tk-sku_popup-chooser">
          <YuScrollView class="tk-sku_popup-scroll_view">
            <TkSkuChooser :sku="this.nNowSku" :skus="oPro.variants" :options="oPro.options" @change="fnChooser" />
          </YuScrollView>
        </div>
        <div v-if="type !== 'cart'" class="tk-sku_popup-num">
          <div class="tk-sku_popup-num_label"><span>购买数量</span><span v-if="nSumStock !== null" class="tk-sku_popup-stock">（库存 {{ nNowStock }} 件）</span></div>
          <YuAmount v-model="nNowQuantity" />
        </div>
        <div class="tk-sku_popup-btns">
          <YuButton class="tk-sku_popup-ok" type="primary" @click="fnSubmit">立即购买</YuButton>
        </div>
      </div>
    </YuPopup>
  </div>
</template>

<script>
import YuPopup from '../YouUI/Popup/Popup'
import YuCurrency from '../YouUI/Currency/Currency'
import YuButton from '../YouUI/Button/Button'
import YuScrollView from '../YouUI/View/ScrollView'
import YuAmount from '../YouUI/Amount/Amount'
import YuIcon from '../YouUI/Icon/Icon'
import TkSkuChooser from './Chooser'

export default {
  componentName: 'TkSkuPopup',
  props: {
    type: {
      type: String,
      default: 'buy'  // buy | quick | confirm | cart
    },
    value: {
      type: Boolean,
      default: false
    },
    product: {
      type: Object,
      default () {
        return {}
      }
    },
    productId: {
      type: Number,
      default: null
    },
    amountAfter: {
      type: Number,
      default: null
    },
    sku: {
      type: Number,
      default: null
    },
    quantity: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      isLock: false,
      onPop: this.value,
      oPro: this.product || {},
      oSku: {},
      oSkuMap: {},
      nNowSku: this.sku || null,
      nSumStock: 0,
      nSumSale: 0,
      nNowQuantity: this.quantity || 1
    }
  },
  computed: {
    nNowStock () {
      let res = this.nSumStock
      if (this.oSku.id) {
        res = this.oSku.stock
      }
      return res
    },
    nNowSale () {
      let res = this.nSumSale
      if (this.oSku.id) {
        res = this.oSku.sale
      }
      return res
    }
  },
  watch: {
    value (val) {
      if (val && this.productId) {
        this.getPro(this.productId, err => {
          if (err) {
            // window.Toast.info(err)
            window.alert(err || '获取商品数据错误')
            this.fnPopChange(false)
          } else {
            this.onPop = val
          }
        })
      } else {
        this.onPop = val
      }
    },
    sku (val) {
      this.nNowSku = val || null
    },
    nNowSku (val) {
      this.initSku()
    },
    oPro (val) {
      this.initSkuMap()
    }
  },
  methods: {
    initSkuMap () {
      const _oSkuMap = {}
      let _nSumStock = 0
      let _nSumSale = 0
      for (let oSku of (this.oPro.variants || [])) {
        _oSkuMap[oSku.id] = oSku
        _nSumStock += oSku.stock
        _nSumSale += oSku.sale
      }
      this.nSumStock = _nSumStock || 0
      this.nSumSale = _nSumSale || 0
      this.oSkuMap = _oSkuMap
      this.initSku()
    },
    initSku () {
      this.oSku = this.oSkuMap[this.nNowSku] || {}
    },
    getPro (nID, cb) {
      window.$tk.sdk.product.get({ids: nID}, data => {
        let err = null
        if (data && data.res) {
          if (data.res.code === 200) {
            this.oPro = (data.res.products || [])[0] || {}
            if (!Object.keys(this.oPro).length) {
              err = '商品数据为空'
            }
          } else {
            err = data.res.message || '商品数据获取出错'
          }
        } else {
          err = '商品数据请求出错'
        }
        cb && cb(err)
      })
    },
    fnClose () {
      this.fnPopChange(false)
    },
    fnPopChange (val) {
      this.$emit('input', val)
    },
    fnChooser (nSku) {
      this.nNowSku = nSku
    },
    fnSubmit () {
      let sku = this.nNowSku || this.sku
      if (sku) {
        this.$emit('change', sku)
        this.fnClose()
      } else {
        if ((this.oPro.options || []).length) {
          window.alert('请选择属性')
        } else {
          sku = ((this.oPro.variants || [])[0] || {}).id
          if (sku) {
            this.$emit('change', sku)
            this.fnClose()
          } else {
            window.alert('数据出错，请刷新页面重试')
          }
        }
      }
    }
  },
  components: {
    YuPopup,
    YuCurrency,
    YuButton,
    YuScrollView,
    YuAmount,
    YuIcon,
    TkSkuChooser
  }
}
</script>

<style>
  .tk-sku_popup-box {
    display: flex;
    flex-direction: column;
    width: 100vw;
    max-height: 70vh;
    -webkit-tap-highlight-color: transparent;
  }
  .tk-sku_popup-info {
    position: relative;
    display: flex;
    padding: 12px 42px 12px 15px;
    height: fill-available;
    max-height: max-content;
  }
  .tk-sku_popup-img_box {
    display: flex;
    margin: auto;
    width: 86px;
    height: 86px;
  }
  .tk-sku_popup-img {
    display: block;
    margin: auto;
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
  .tk-sku_popup-pro {
    flex: 1;
    margin: auto;
    padding: 0 0 0 10px;
  }
  .tk-sku_popup-name {
    line-height: 1.3em;
    overflow : hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .tk-sku_popup-prices {
    margin: 8px 0 0;
    font-size: 0;
    line-height: 1;
  }
  .tk-sku_popup-price_link {
    font-weight: bold;
    font-size: 16px;
    color: #f44;
  }
  .tk-sku_popup-price {
    font-weight: bold;
    font-size: 16px;
    color: #f44;
  }
  .tk-sku_popup-price_max {
    font-weight: bold;
    font-size: 16px;
    color: #f44;
  }
  .tk-sku_popup-price_max .yu-currency-symbol {
    display: none;
  }
  .tk-sku_popup-price_src {
    margin: 0 0 0 10px;
    font-size: 16px;
    color: #999;
    text-decoration: line-through;
  }
  .tk-sku_popup-count {
    margin: 8px 0 0;
    color: #999;
  }
  .tk-sku_popup-count_stock {
    margin: 0 10px 0 0;
  }
  button.tk-sku_popup-close {
    position: absolute;
    top: 0;
    right: 0;
    margin: 0;
    padding: 15px;
    color: #999;
    font-size: 0;
  }
  .tk-sku_popup-close:active {
    color: #888;
  }
  .tk-sku_popup-close_icon {
    display: inline-block;
    width: 14px;
    height: 14px;
  }
  .tk-sku_popup-chooser {
    display: flex;
    flex: 1;
    overflow: hidden;
    border: 0 solid #d5d5d5;
    border-width: .5px 0 0;
    max-height: min-content;
    -webkit-overflow-scrolling: touch;
  }
  .tk-sku_popup-chooser .tk-sku_popup-scroll_view {
    box-sizing: border-box;
    padding: 12px 15px 36px;
    width: 100%;
  }
  .tk-sku_popup-num {
    display: flex;
    padding: 12px 15px;
    border: 0 solid #d5d5d5;
    border-width: .5px 0 0;
  }
  .tk-sku_popup-num_label {
    flex: 1;
    margin: auto;
  }
  .tk-sku_popup-btns {
    display: flex;
    height: fill-available;
    max-height: max-content;
  }
  .tk-sku_popup-btns .yu-btn {
    flex: 1;
    margin: 0;
    padding: 16px 0;
    border: none;
    border-radius: 0;
    font-size: 18px;
  }
  .tk-sku_popup-on {
    background-color: #999;
  }
  .tk-sku_popup-on:active {
    background-color: #888;
  }
</style>



// WEBPACK FOOTER //
// Popup.vue?02eed962